<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>
  
  <form
    class="card-form"
    [formGroup]="motorForm"
    (ngSubmit)="submitForm()"
    novalidate
  >
    <div class="blue-top"></div>
    <div class="card-section top-section">
      <h1>
        <b>{{ pageHeading }}</b>
      </h1>
      <h2>{{ pageSubheading }}</h2>

      <div formArrayName="witnesses">
        <div *ngFor="let witness of getWitnesses().controls; let i=index" [formGroupName]="i">

          <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0">
            <button mat-stroked-button type="button" (click)="removeWitness(i)">
              <span class="button-text">{{ remove }}</span>
            </button>
          </div>

          <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
            <mat-label class="form-select-placeholder-unselected">
              {{witnessNameLabel}}
            </mat-label>
            <input matInput formControlName="witnessName" (blur)="logErrors()" />
            
            <mat-error *ngIf="formErrors['witnessName']">
              {{ formErrors["witnessName"] }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
            <mat-label class="form-select-placeholder-unselected">
              {{witnessTelLabel}}
            </mat-label>
            <input matInput formControlName="witnessTel" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['witnessTel']">
              {{ formErrors["witnessTel"] }}
            </mat-error>
          </mat-form-field>

          <div class="divider-line"></div>
        </div>
      </div>

      <!-- BUTTTON aDD wITNESS -->
      <div class="row-div general-stroked-button">
        <button mat-stroked-button type="button" (click)="addNewWitness()">
          <span class="button-text">+&nbsp;&nbsp;{{ addWitnessLabel }}</span>
        </button>
      </div>
      
    </div>

    <div class="card-section bottom-section">
      <h2>{{ passengerDetailsSubheading }}</h2>

      <div formArrayName="passengers" >
        <div *ngFor="let passenger of getPassengers().controls; let i=index" [formGroupName]="i">
          <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0">
            <button mat-stroked-button type="button" (click)="removePassenger(i)">
              <span class="button-text">{{ remove }}</span>
            </button>
          </div>

          <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
            <mat-label class="form-select-placeholder-unselected">
              {{ passengerNameLabel }}</mat-label>
            <input matInput formControlName="passengerName" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['passengerName']">
              {{ formErrors["passengerName"] }}
            </mat-error>
          </mat-form-field>
    
          <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
            <mat-label class="form-select-placeholder-unselected">
              {{ passengerTelLabel }}</mat-label>
            <input
              matInput
              formControlName="passengerTel"
              (blur)="logErrors()"
            />
            <mat-error *ngIf="formErrors['passengerTel']">
              {{ formErrors["passengerTel"] }}
            </mat-error>
          </mat-form-field>
          
          <div class="divider-line"></div>
        </div>
      </div>

      <!-- BUTTTON aDD Passenger -->
      <div class="row-div general-stroked-button">
        <button mat-stroked-button type="button" (click)="addNewPassenger()" style="border-radius: 5px; width: fit-content;">
          <span class="button-text">+&nbsp;&nbsp;{{ addPassengerLabel }}</span>
        </button>
      </div>

    </div>

    <div class="card-section bottom-section">
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          fullNameLabel
        }}</mat-label>
        <input matInput formControlName="fullName" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['fullName']">
          {{ formErrors["fullName"] }}
        </mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
      >
        <mat-label class="form-select-placeholder-unselected">{{
          dateLabel
        }}</mat-label>
        <input
          matInput
          [min]="maxDate"
          [max]="maxDate"
          [matDatepicker]="picker"
          readonly="true"
          (click)="picker.open()"
          formControlName="date"
          (blur)="logErrors()"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker> </mat-datepicker>
        <mat-error *ngIf="formErrors['date']">
          {{ formErrors["date"] }}
        </mat-error>
      </mat-form-field>

      <div class="simple_checkbox width-100pc margin-bottom-40 margin-top-30">
        <mat-checkbox formControlName="iSwear" (blur)="logErrors()" style="margin-bottom: 10px;">
          <p class="checkbox-p" [innerHTML]="iSwearText | dompurify"></p>
        </mat-checkbox>
        <mat-error *ngIf="formErrors['iSwear']">
          {{formErrors["iSwear"]}}
        </mat-error>
      </div>

      <div class="row-div">
        <button mat-stroked-button type="button" (click)="cancelApplication()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="motorForm.controls['iSwear'].value === false || !motorForm.valid">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
